// Round profile picture; the first letter of the name on green when there's no photo. `dashed`: someone without
// the app (Người chưa dùng app), a letter in a dashed circle.
export default function Avatar({ name, url, size = 44, className = '', dashed = false }) {
  const initial = (name || '').trim().charAt(0).toUpperCase() || 'M';
  if (dashed) {
    return (
      <span aria-hidden="true" className={`grid shrink-0 place-items-center rounded-full border-2 border-dashed border-[#9aa59f] bg-base-100 font-bold text-muted ${className}`}
        style={{ width: size, height: size, fontSize: size * 0.4 }}>
        {initial}
      </span>
    );
  }
  return url ? (
    <img src={url} alt="" className={`shrink-0 rounded-full object-cover ${className}`} style={{ width: size, height: size }} />
  ) : (
    <span aria-hidden="true" className={`grid shrink-0 place-items-center rounded-full bg-primary font-bold text-primary-content ${className}`}
      style={{ width: size, height: size, fontSize: size * 0.42 }}>
      {initial}
    </span>
  );
}
